module.exports = __webpack_public_path__ + "img/TS_Inline_Light_512.fd75c49b.png";